export const getPages = (pageCount:number, page: number | undefined = undefined): string[] => {
    const pages: string[] = []
    if (pageCount > 10) {
        for (let i = 1; i <= 3; i++) {
            pages.push(i.toString())
        }
        pages.push('...')
        if (page && page > 3 && page < pageCount - 2) {
            pages.push(page.toString())
            pages.push('...')
        }
        for (let i = pageCount - 2; i <= pageCount; i++) {
            pages.push(i.toString())
        }
        return pages;
    }
    for (let i = 1; i <= pageCount; i++) {
        pages.push(i.toString())
    }
    return pages;
}
